import { Input } from "ant-design-vue";
import "./src/input.less"
const { Search, TextArea, Group, Password, ...other } = Input;

const YwInput = {
	...other,
	name: "YwInput",
	Search: {
		...Search,
		name: "YwInputSearch",
	},
	TextArea: {
		...TextArea,
		name: "YwInputTextArea",
	},
	Group: {
		...Group,
		name: "YwInputGroup",
	},
	Password: {
		...Password,
		name: "YwInputPassword",
	},
};

YwInput.install = function (Vue) {
	Vue.component(YwInput.name, Input);
	Vue.component(YwInput.Search.name, Input.Search);
	Vue.component(YwInput.Group.name, Input.Group);
	Vue.component(YwInput.TextArea.name, Input.TextArea);
	Vue.component(YwInput.Password.name, Input.Password);
};


export default YwInput;
